<div *ngIf="headers">
    <div class="table-name">
        <span>{{tableName}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
        <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
        <span *ngIf="tableoption && ValidatorOSBFieldObject()">
            <span *ngIf="tableoption.search">
                <button nz-button nzType="primary" class="table-title-button" (click)="FindDataByOSB(this, object.formCode, object.environment + 
            + object.fieldCode + object.fieldTypeCode + object.formVersion,false)">
                    <span nz-icon nzType="search"></span>
                </button>
            </span>
            <span *ngIf="tableoption.refresh">
                <button nz-button nzType="primary" class="table-title-button" (click)="FindDataByOSB(this, object.formCode, object.environment + 
                                        + object.fieldCode + object.fieldTypeCode + object.formVersion, true)">
                    <span nz-icon nzType="reload"></span>
                </button>
            </span>
        </span>
        <span *ngIf="tableoption && tableoption.add">
            <button nz-button nzType="primary" class="table-title-button" id="btnAdd"
                (click)="openModal($event,null, -1)">
                <span nz-icon nzType="plus"></span>
            </button>
        </span>
        <span *ngIf="tableoption && tableoption.configcolumn">
            <button nz-button nzType="primary" class="table-title-button">
                <span nz-icon nzType="setting"></span>
            </button>
        </span>
    </div>
</div>
<nz-skeleton [nzLoading]="!(headers.length > 0)" nzActive="true"></nz-skeleton>
<div class="current-form bootstrap-cols table-complex step object.step input-element table-complex"
    *ngIf="headers.length==0"></div>
<div class="table-container" *ngIf="headers.length > 0">
    <nz-table nzTemplateMode [id]="formFieldInfo.fieldCode" [nzData]="tableShowValues" [nzShowPagination]="false">
        <thead>
            <tr class="row-head">
                <th scope="col" style="min-width: 110px;text-align: left;">Thao tác</th>
                <th *ngIf="tableoption && tableoption.status && tableoption.status.enabled"
                    style="width: 100px; text-align : center">
                    Trạng thái
                </th>
                <th *ngFor="let h of headers" class="table-header" id="{{h.fieldCode}}"> {{displayName(h)}} </th>
            </tr>
        </thead>
        <tbody>
            <!-- <tr > -->
            <tr *ngFor="let row of tableShowValues; let i = index">
                <td class="col-action">
                    <span *ngIf="tableoption.delete">
                        <button nz-button (click)="deleteData(i)" class="button-danger find-osb-table" title="Xóa">
                            <span nz-icon nzType="delete"></span>
                        </button>
                    </span>
                    <span *ngIf="tableoption.view">
                        <button nz-button (click)="editData($event,i)" nzType="primary" title="Xem">
                            <span nz-icon nzType="eye"></span>
                        </button>
                    </span>
                    <span *ngIf="tableoption.edit">
                        <button nz-button (click)="editData($event,i)" class="button-warning find-osb-table editdata"
                            title="Sửa">
                            <span nz-icon nzType="edit"></span>
                        </button>
                    </span>
                </td>
                <td *ngIf="tableoption && tableoption.status && tableoption.status.enabled" scope="cell"
                    style="text-align : center">
                    STATRECORD_VALUE
                </td>
                <td *ngFor="let cell of headers" [attr.data-code]="cellValue(row, cell).saveData">
                    {{cellValue(row, cell).cellValue}}
                </td>
                <!-- <td *ngFor="let row of tableShowValues; let i = index" [attr.data-code]="row.dataCode">
                    {{row.dataValue}}
                </td> -->
            </tr>
        </tbody>
    </nz-table>
</div>